import React from "react";
import CustomContainer from "../components/CustomContainer";
import {
  Box,
  Button,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import SocialContact from "../components/SocialContact";
import TypingEffect from "../components/TypingEffect";
import { useTranslation } from "react-i18next";
import { AboutProps } from "../@types/types";

const About: React.FC<AboutProps> = ({
  greeting,
  fullName,
  role,
  description,
  socialLinks,
  profileImageUrl,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <CustomContainer id="#about" display="flex" alignItems="center">
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        spacing={2}
        direction={isMobile ? "column-reverse" : "row"}
      >
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" color="textSecondary" gutterBottom>
            {t(greeting)}
          </Typography>
          <Typography variant="h2" component="h2" gutterBottom>
            {t(fullName)}
          </Typography>

          <TypingEffect
            text={role}
            typingSpeed={100}
            deletingSpeed={50}
            delay={1000}
            variant="h4"
          />

          {description.map((line, index) => (
            <Typography key={index} variant="h6" paragraph gutterBottom>
              {t(line)}
            </Typography>
          ))}
          <Stack direction={"row"} spacing={2}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                document!
                  .getElementById("#projects")!
                  .scrollIntoView({ behavior: "smooth" });
              }}
            >
              {t("View Projects")}
            </Button>
            <SocialContact links={socialLinks} />
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box
            component="img"
            height="auto"
            sx={{
              width: { xs: "100%", sm: "90%" },
              borderRadius: "27% 73% 40% 60% / 43% 37% 63% 57%",
            }}
            alt="profile-image"
            src={profileImageUrl || "https://placehold.co/600x400"}
          />
        </Grid>
      </Grid>
    </CustomContainer>
  );
};

export default About;
